<template>
  <ChapterGridPdfTemplateItem
    :path="routeLink.path"
    :handle-click-path="handleClickPath"
    :thumbnail-media="thumbnailMedia"
    :title="category.title"
    :is-trial-item="isTrialItem"
  />
</template>
<script lang="ts" setup>
interface ViewProps {
  category: CategorySchema;
}

const props = defineProps({
  category: null
});

const { mPageMedias } = inject(INJECT_CATEGORY_PAGE);

const thumbnailMedia = computed(() => {
  const post = props.category.posts[0];
  const _media =
    post && post.medias && post.medias.length > 0 ? post.medias[0] : null;
  if (_media) {
    return mPageMedias.value.get(_media.id);
  }
  return null;
});

const { handleClickPath, isTrialItem, routeLink } =
  await useCategoryLinkTryAndLock(props.category);
</script>
<style lang="scss" scoped>
.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap_s);
}
.header {
  display: flex;
  position: relative;
  flex-direction: column;
  padding: var(--gap_m);
  overflow: hidden;
  border-color: var(--color_neutral_25);
  gap: var(--gap_xs);
  @include stroke('l', 'm');
  &::after {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-origin: 50% 50%;
    transition: opacity 300ms $ease-in-quad;
    background-color: var(--color_secondary_lighter);
  }
}

.image {
  position: relative;
}

.thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: calc(var(--stroke_radius_m) - var(--gap_m) / 2);
}
.actions {
  display: flex;
  z-index: 1;
  justify-content: flex-end;
  background-color: var(--color_secondary_lighter);
  gap: var(--gap_xs);
}
img {
  z-index: 1;
  transition: box-shadow 340ms $ease-in-quad;
  box-shadow: rgb(0 0 0 / 0%) 0 2px 8px;
}
h4 {
  /* Calcul littéral et équations */
  @include font('s', 500, 'secondary');

  padding: 0 var(--gap_s);
  transition: color 300ms $ease-in-quad;
  text-align: center;
}

a {
  &:hover,
  &:focus {
    .header {
      &::after {
        transition: opacity 300ms $ease-out-quad;
        opacity: 0.5;
      }
    }
    h4 {
      transition: color 300ms $ease-out-quad;
      color: var(--color_secondary);
    }
    img {
      transition: box-shadow 340ms $ease-out-quad;
      box-shadow: rgb(0 0 0 / 10%) 0 2px 8px;
    }
  }
}
</style>
